import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'input-textarea',
  shadow: false,
})
export class Textarea {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() value: string;
  @Prop() required: boolean;
  @Prop() placeholder: string;
  @Prop() tooltip: string;
  @Prop() maxLength: number;
  @Prop() minLength: number;
  @Prop() disabled: boolean;
  @Prop() dataTab: string;

  render() {
    return (
      <div class="mb-3">
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <textarea
          class="form-control form-control"
          id="exampleFormControlTextarea1"
          data-tab={this.dataTab}
          placeholder={this.placeholder}
          name={this.name}
          required={this.required}
          value={this.value}
          minLength={this.minLength}
          maxLength={this.maxLength}
          disabled={this.disabled}
        ></textarea>
      </div>
    );
  }
}
